import Icon from 'snippets/icon/icon'

function CustomModalDialog({
  header,
  content,
  footer,
  id,
  scrollTarget = '.modal-dialog-inner',
  type = 'modal',
  classClose = 'size-8 p-2',
  classMain = '',
  classContent = '',
  classHeader = '',
  classIcon = 'size-4 text-grey-500',
  title
}) {
  return (
    <modal-dialog id={id} data-target={id} data-type={type} data-scroll-target={scrollTarget}>
      <div
        className={`modal-dialog-content js-content-modal-dialog relative ${classMain}`}
        aria-modal="true"
        role="dialog"
        aria-label={title && title}
      >
        <div className={`relative ${classHeader}`}>
          {header}
          <button
            type="button"
            className={`js-close-modal-dialog flex justify-center items-center absolute right-4 top-3 size-8 p-2 md:size-10 md:right-6 md:top-4 ${classClose}`}
            aria-label="close modal"
          >
            <Icon name="icon-close" viewBox="0 0 24 24" className={classIcon} />
          </button>
        </div>
        <div className={`modal-dialog-inner ${classContent}`}>{content}</div>
        {footer}
      </div>
    </modal-dialog>
  )
}

export default CustomModalDialog
